import axios from '@/utils/api'

const URL_NOTIFICACOES = `notificacoes`

const actions = {
  find ({ commit }, filtro) {
    return axios({
      method: 'post',
      loader: false,
      url: `${URL_NOTIFICACOES}/find`,
      data: filtro
    })
  },

  marcarComoLida ({ commit }, ids) {
    return axios({
      method: 'post',
      url: `${URL_NOTIFICACOES}/marcarComoLida`,
      loader: false,
      data: ids
    })
  },

  getQuantidadeNaoLidas ({ commit }) {
    return axios({
      method: 'get',
      loader: false,
      url: `${URL_NOTIFICACOES}/quantidadeNaoLidas`
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/notificacoes.js